import { useState, useEffect, useRef } from 'react';
import { Container, Form, Row, Col, Card, Spinner, Button, Toast, ToastContainer } from "react-bootstrap";
import { createClient } from "@supabase/supabase-js";
import { v4 as uuidv4 } from "uuid";
import SEO from "../components/SEO";

const supabase = createClient(
  "https://pgwzdhbxjtoslmjlsrtv.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBnd3pkaGJ4anRvc2xtamxzcnR2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIwNjgyODAsImV4cCI6MjA1NzY0NDI4MH0.RIatnz1oTIvuvb8iv7_7gtaILAUv6oUa6dpUpfaHjD4" // Replace with your anon key
);

const CDNURL = "https://pgwzdhbxjtoslmjlsrtv.supabase.co/storage/v1/object/public/filesuploads/";
const ADMIN_EMAIL = "juliussunday909@gmail.com";

const Gallery = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success");
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const videoRefs = useRef([]);

  async function getVideos() {
    setLoading(true);
    const { data, error } = await supabase
      .storage
      .from("filesuploads")
      .list("videos", { limit: 100, offset: 0, sortBy: { column: 'created_at', order: 'desc' } });

    if (data) {
      setVideos(data);
    } else {
      console.log(error);
      setToastMessage("Error grabbing files from Supabase");
      setToastVariant("danger");
      setShowToast(true);
    }
    setLoading(false);
  }

  useEffect(() => {
    getVideos();

    // Check login session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user || null);
    });

    // Auth state change listener
    supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user || null);
    });
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("video/")) {
      setToastMessage("Only video files are allowed!");
      setToastVariant("danger");
      setShowToast(true);
      return;
    }

    setSelectedFile(file);
  };

  const uploadFile = async () => {
    if (!selectedFile) {
      setToastMessage("Please select a video file first!");
      setToastVariant("danger");
      setShowToast(true);
      return;
    }

    setLoading(true);

    const fileExtension = selectedFile.name.split('.').pop();
    const filePath = `videos/${uuidv4()}.${fileExtension}`;

    const { data, error } = await supabase.storage
      .from("filesuploads")
      .upload(filePath, selectedFile, { contentType: selectedFile.type });

    if (error) {
      console.error("Upload Error:", error.message);
      setToastMessage("Error uploading file to Supabase!");
      setToastVariant("danger");
      setShowToast(true);
    } else {
      console.log("Upload Success:", data);
      setToastMessage("Video uploaded successfully!");
      setToastVariant("success");
      setShowToast(true);
      await getVideos();
      setSelectedFile(null); // Clear after upload
    }

    setLoading(false);
  };

  const handlePlay = (index) => {
    videoRefs.current.forEach((video, i) => {
      if (video && i !== index) {
        video.pause();
      }
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const { error, data } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setToastMessage("Login failed: " + error.message);
      setToastVariant("danger");
      setShowToast(true);
    } else {
      setToastMessage("Login successful!");
      setToastVariant("success");
      setShowToast(true);
      setUser(data.user);
      setEmail("");
      setPassword("");
    }
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setUser(null);
    setToastMessage("Logged out!");
    setToastVariant("success");
    setShowToast(true);
  };

  return (
    <>
      <SEO
        title="Student Testimonials - Adeleke Tennis Academy"
        description="Read reviews and testimonials from students who have trained with Julius Adeleke at Adeleke Tennis Academy."
        keywords="Tennis Student Reviews, Adeleke Tennis Academy Testimonials, Julius Adeleke Reviews"
        url="https://www.adeleketennisacademy.com/testimonial"
        image="https://julius-s-adeleke.web.app/julius.jpg"
      />

    <div style={{ backgroundColor: "#000" }}>
      <Container className="text-white pt-5" style={{ backgroundColor: "#000" }}>
        <h1 className="mb-4" style={{ color: "blue", paddingTop: 25 }}>Video Feed</h1>

        {/* Login Form */}
        {!user && (
          <Form onSubmit={handleLogin} className="mb-4 mt-3">
            <Form.Group className="mb-3">
              <Form.Label>Login to Upload Videos</Form.Label>
              <Form.Control
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>
            <Button type="submit" variant="success">Login</Button>
          </Form>
        )}

        {/* Upload Form only visible to owner */}
        {user && user.email === ADMIN_EMAIL && (
          <>
            <Form.Group className="mb-3 mt-3">
              <Form.Label className='fst-italic'>Upload your videos here</Form.Label>
              <Form.Control 
                type="file" 
                accept="video/*" 
                onChange={handleFileChange} 
                disabled={loading}
              />
            </Form.Group>

            {selectedFile && (
              <div className="mb-3">
                <strong>Selected File:</strong> {selectedFile.name}
              </div>
            )}

            <Button 
              variant="primary" 
              onClick={uploadFile} 
              disabled={!selectedFile || loading}
              className="d-flex align-items-center gap-2"
            >
              {loading && <Spinner animation="border" size="sm" />}
              {loading ? "Uploading..." : "Upload Video"}
            </Button>

            <Button variant="danger" onClick={handleLogout} className="mt-3">Logout</Button>
          </>
        )}

        {loading && (
          <div className="text-center my-4">
            <Spinner animation="border" role="status" />
            <div>Loading...</div>
          </div>
        )}

        <div className='text-center fw-bold fs-3 mb-4 mt-5'>
          <h3>WATCH COACH JULIUS IN ACTION</h3>
        </div>

        {!loading && (
          <Row xs={1} md={2} lg={3} className="g-4 pb-5">
            {videos.map((video, index) => (
              <Col key={index}>
                <Card className="bg-dark text-white border-0 shadow-lg h-100">
                  <video
                    width="100%"
                    height="220px"
                    controls
                    ref={(el) => (videoRefs.current[index] = el)}
                    onPlay={() => handlePlay(index)}
                    style={{ borderRadius: "10px" }}
                  >
                    <source src={CDNURL + "videos/" + video.name} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </Card>
              </Col>
            ))}
          </Row>
        )}

        {/* Toast Notification */}
        <ToastContainer position="bottom-end" className="p-3">
          <Toast 
            onClose={() => setShowToast(false)} 
            show={showToast} 
            delay={3000} 
            autohide
            bg={toastVariant}
          >
            <Toast.Body className="text-white">{toastMessage}</Toast.Body>
          </Toast>
        </ToastContainer>

      </Container>
    </div>
    </>
  );
};

export default Gallery;
